import { createSelector } from '@reduxjs/toolkit';

export const selectLogin = createSelector(
  ({ login }) => login,
  (state) => state,
);
